"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = providerSignupReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _ProviderSignupFields = _interopRequireDefault(require("../constants/providerSignup/ProviderSignupFields"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _fromJS;

var initialState = (0, _immutable.fromJS)((_fromJS = {
  submissionRequestStatus: _RequestStatusTypes.default.UNINITIALIZED,
  fieldsWithErrors: {}
}, (0, _defineProperty2.default)(_fromJS, _ProviderSignupFields.default.FIRST_NAME, ''), (0, _defineProperty2.default)(_fromJS, _ProviderSignupFields.default.LAST_NAME, ''), (0, _defineProperty2.default)(_fromJS, _ProviderSignupFields.default.CONTACT_EMAIL, ''), (0, _defineProperty2.default)(_fromJS, _ProviderSignupFields.default.WEBSITE, ''), (0, _defineProperty2.default)(_fromJS, _ProviderSignupFields.default.PASSWORD, ''), (0, _defineProperty2.default)(_fromJS, _ProviderSignupFields.default.PASSWORD_CONFIRMATION, ''), _fromJS));

function providerSignupReducer() {
  var providerSignup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.PROVIDER_SIGNUP_FIELD_CHANGED:
      return providerSignup.set(action.payload.field, action.payload.inputText);

    case _ActionTypes.default.PROVIDER_SIGNUP_FORM_SUBMITTED:
      if (action.error) {
        return providerSignup.merge({
          submissionRequestStatus: _RequestStatusTypes.default.FAILED,
          fieldsWithErrors: action.payload
        });
      }

      return providerSignup.set('submissionRequestStatus', _RequestStatusTypes.default.PENDING);

    case _ActionTypes.default.DISMISSED_PROVIDER_SIGNUP_ERROR:
      return providerSignup.set('submissionRequestStatus', _RequestStatusTypes.default.UNINITIALIZED);

    default:
      return providerSignup;
  }
}

module.exports = exports.default;